import React from "react";
import styles from "./MenuTop.module.css";

import PhoneIcon from "@material-ui/icons/Phone";
import FacebookIcon from "@material-ui/icons/Facebook";
import YouTubeIcon from "@material-ui/icons/YouTube";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { IconButton, Tooltip } from "@material-ui/core";

const data = {
  phoneNumber: process.env.REACT_APP_ADMIN_PHONE,
  email: process.env.REACT_APP_ADMIN_EMAIL,
  facebook: process.env.REACT_APP_ADMIN_FACEBOOK,
  youtobe: process.env.REACT_APP_ADMIN_YOUTOBE,
};

function MenuTop() {
  return (
    <div className={styles.container}>
      <Tooltip title={`${data.phoneNumber}`}>
        <IconButton href={`tel:${data.phoneNumber}`} target="_blank">
          <PhoneIcon fontSize="small" className={styles.icon_item} />
        </IconButton>
      </Tooltip>

      {/* <Tooltip title={`${data.youtobe}`}>
        <IconButton href={`${data.youtobe}`} target="_blank" color="secondary">
          <YouTubeIcon fontSize="small" className={styles.icon_item} />
        </IconButton>
      </Tooltip> */}

      <Tooltip title={`${data.email}`}>
        <IconButton
          href={`mailto:${data.email}`}
          target="_blank"
          color="secondary"
        >
          <MailOutlineIcon fontSize="small" className={styles.icon_item} />
        </IconButton>
      </Tooltip>

      <Tooltip title={`${data.facebook}`}>
        <IconButton href={`${data.facebook}`} target="_blank" color="primary">
          <FacebookIcon fontSize="small" className={styles.icon_item} />
        </IconButton>
      </Tooltip>
    </div>
  );
}

export default MenuTop;
